export default __webpack_public_path__ + "5ac6d7ee6f051502dd90e6cb0235e930.png";